import {
  BalanceCreditInfoApiResponse,
  BalancePortalUrlApiResponse,
} from 'src/types/Balance';

export enum BalancePortalPage {
  PAYMENT_METHODS = 'payment-methods',
  OUTSTANDING_INVOICES = 'outstanding',
  PAID = 'paid',
}

export type BalanceContextValue = {
  externalBalanceBuyerId: string | null;

  creditInfo: BalanceCreditInfoApiResponse | null;
  isCreditInfoLoading: boolean;
  hasCreditInfoError: boolean;

  portalUrl: BalancePortalUrlApiResponse | null;
  isPortalUrlLoading: boolean;
  hasPortalUrlError: boolean;

  isOnNetTerms: boolean | null;
};

export enum BalanceBannerType {
  CreditLimitApproaching = 'creditLimitApproaching',
  ServiceUnavailable = 'serviceUnavailable',
  SuspendedGeneric = 'suspendedGeneric',
  SuspendedInvoices = 'suspendedInvoices',
  SuspendedSecurity = 'suspendedSecurity',
}
